/* X-STESURA 29/10/2026. Page «Chi siamo», last card of the closing credits (sections/bh-q4d-chisiamo-coda.liquid, bh-x-stesura.css).
   «The second draft»: when the card comes into view it types ART NEEDS APPROVAL with a human pace, stops, the caret goes back to before
   APPROVAL and writes NO in the brand red with a pen mark under it; then the typed copy goes away and the real line stays, with NO in red.
   Once per session (sessionStorage «bh-x-stesura»): on the next pages of the same session the line is already the final one, NO in red
   with the pen mark, and nothing plays. If the storage can't be used, the scene plays on every view. Then nothing is left running: no
   timer, no observer, no listener, no animation.
   The real line is the HTML of the section and is never hidden from screen readers (only transparent while the copy plays); the copy is
   aria-hidden. Nothing happens at load: an IntersectionObserver one screen away prepares the copy, a second one starts it. It pauses out of
   view, with the tab hidden and while a drawer or the cookie dialog is open (html[data-bh-int-tema]). «Reduce motion», no
   IntersectionObserver or no stylesheet: the line stays as it is.

   Basato su Second Draft Text di ham7a311 (21st.dev), licenza MIT, Copyright (c) 2026 ham7a311
   https://21st.dev/@ham7a311/components/second-draft-text (the pace of the keys, the pen mark and the caret come from there; React, the
   demo texts, the draft counter and the replay button are gone).

   MIT License

   Copyright (c) 2026 ham7a311

   Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR
   ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH
   THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
(function () {
  if (window.__bhXStesura) return;
  window.__bhXStesura = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var riga = document.querySelector('.bh-q4dc-coda__fine');
  var no = riga && riga.querySelector('.bh-x-stesura__no');
  if (!no) return;

  var PRIMA = 'ART NEEDS', DOPO = ' APPROVAL', ROSSO = 'NO';
  var NS = 'http://www.w3.org/2000/svg';
  var SEGNO = 'M3 9 C 30 15, 70 15, 104 8 C 112 6, 117 5, 116 10 C 114 16, 96 18, 84 15';
  var html = document.documentElement;
  var copia, cursore, passi = [], i = 0, timer = 0, inVista = false, vicino, vista, mo, fatto = false;
  var CHIAVE = 'bh-x-stesura';

  function el(tag, cls, testo) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (testo != null) e.textContent = testo;
    return e;
  }
  function segno(ferma) {
    var s = document.createElementNS(NS, 'svg');
    s.setAttribute('class', 'bh-x-stesura__segno');
    s.setAttribute('viewBox', '0 0 120 24');
    s.setAttribute('preserveAspectRatio', 'none');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    var p = document.createElementNS(NS, 'path');
    p.setAttribute('d', SEGNO);
    s.appendChild(p);
    return s;
  }
  /* the pace of a key, from Second Draft Text: slower after a space, a bit of breath on spaces */
  function ritmo(c, prima) {
    var x = 55 + Math.random() * 55;
    if (c === ' ') x += 40 + Math.random() * 60;
    if (prima === ' ') x *= 0.7;
    return x * 1.25;
  }

  function prepara() {
    copia = el('span', 'bh-x-stesura__copia');
    copia.setAttribute('aria-hidden', 'true');
    var testo = PRIMA + DOPO, lettere = [];
    for (var k = 0; k < testo.length; k++) {
      var c = el('span', 'bh-x-stesura__c', testo.charAt(k));
      lettere.push(c);
      copia.appendChild(c);
    }
    cursore = el('span', 'bh-x-stesura__cursore');
    copia.insertBefore(cursore, copia.firstChild);
    riga.appendChild(copia); /* hidden by the stylesheet until the scene really starts: until then the real line shows */

    var dopoNeeds = lettere[PRIMA.length]; /* the space before APPROVAL: the correction goes in front of it */
    var rosso = el('span', 'bh-x-stesura__no');
    function scrivi(c) { cursore.setAttribute('data-scrive', ''); c.classList.add('is-su'); c.parentNode.insertBefore(cursore, c.nextSibling); }
    function aspetta() { cursore.removeAttribute('data-scrive'); }

    lettere.forEach(function (c, k) {
      passi.push([(k ? 0 : 900) + ritmo(c.textContent, k ? lettere[k - 1].textContent : ' '), function () { scrivi(c); }]);
    });
    passi.push([0, aspetta]);
    /* back over APPROVAL and its space, one key at a time */
    for (var b = lettere.length - 1; b >= PRIMA.length; b--) {
      (function (c, primo) {
        passi.push([primo ? 1100 : 80, function () { cursore.setAttribute('data-scrive', ''); c.parentNode.insertBefore(cursore, c); }]);
      })(lettere[b], b === lettere.length - 1);
    }
    passi.push([0, aspetta]);
    /* « NO»: the space plain, the two letters in red, slower, like a pen */
    passi.push([480, function () {
      var s = el('span', 'bh-x-stesura__c is-su', ' ');
      copia.insertBefore(s, dopoNeeds);
      copia.insertBefore(rosso, dopoNeeds);
      rosso.appendChild(cursore);
      cursore.setAttribute('data-scrive', '');
    }]);
    ROSSO.split('').forEach(function (ch, k) {
      passi.push([ritmo(ch, k ? 'N' : ' ') * 1.7, function () { rosso.insertBefore(el('span', 'bh-x-stesura__c is-su', ch), cursore); }]);
    });
    passi.push([260, function () { aspetta(); rosso.appendChild(segno()); }]);
    passi.push([3100, fine]);
  }

  function ferma() { if (timer) { clearTimeout(timer); timer = 0; } }
  function libero() { return inVista && !document.hidden && !html.hasAttribute('data-bh-int-tema'); }
  function vai() {
    ferma();
    if (fatto || !libero() || i >= passi.length) return;
    riga.classList.add('bh-x-stesura-on');
    timer = setTimeout(function () {
      timer = 0;
      var p = passi[i++];
      p[1]();
      if (!fatto) vai();
    }, passi[i][0]);
  }
  function fine() {
    fatto = true;
    ferma();
    if (vista) vista.disconnect();
    if (mo) mo.disconnect();
    document.removeEventListener('visibilitychange', vai);
    riga.classList.remove('bh-x-stesura-on');
    if (copia && copia.parentNode) copia.parentNode.removeChild(copia);
    copia = cursore = null;
    passi = [];
    finale();
    try { sessionStorage.setItem(CHIAVE, '1'); } catch (e) {}
  }
  /* the line as the scene leaves it: NO in red with the pen mark, still */
  function finale() {
    no.appendChild(segno());
    riga.classList.add('bh-x-stesura-fatta');
    riga.setAttribute('data-bh-x-stesura', 'fatta');
  }

  function parti() {
    prepara();
    vista = new IntersectionObserver(function (v) {
      inVista = v[v.length - 1].isIntersecting;
      vai();
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.9 });
    vista.observe(riga);
    document.addEventListener('visibilitychange', vai);
    if ('MutationObserver' in window) {
      mo = new MutationObserver(vai);
      mo.observe(html, { attributes: true, attributeFilter: ['data-bh-int-tema'] });
    }
  }
  /* the stylesheet comes in late (media="print" onload): without it the copy would sit out of place, so it waits for it */
  function stile() { return getComputedStyle(riga).getPropertyValue('--bh-x-stesura').trim() === '1'; }
  function quandoStile(f) {
    if (stile()) return f();
    var l = document.querySelector('link[href*="bh-x-stesura"]');
    if (!l) return;
    l.addEventListener('load', function () { if (stile()) f(); }, { once: true });
  }

  var giaVista = false;
  try { giaVista = sessionStorage.getItem(CHIAVE) === '1'; } catch (e) {}
  if (giaVista) return quandoStile(finale);

  vicino = new IntersectionObserver(function (v) {
    if (!v[v.length - 1].isIntersecting) return;
    vicino.disconnect();
    quandoStile(parti);
  }, { rootMargin: '100% 0px 100% 0px' });
  vicino.observe(riga);
})();
